import moment from 'moment';

export const getDateRange = (prevDaysOffset?: number, fromDateOffset?: string) => {
  const today = moment.utc().format('YYYY-MM-DDTHH:mm:ssZ');
  const prevDay = moment().utc().subtract(prevDaysOffset, 'days').format('YYYY-MM-DDTHH:mm:ssZ');
  const fromDate = moment.utc().subtract(fromDateOffset, 'days').format('YYYY-MM-DDTHH:mm:ssZ');

  const new_today = 'now';
  const new_prevDay = "now - duration 'P1D'";
  const new_fromDate = `now - duration '${fromDateOffset}'`;

  return { today, prevDay, fromDate, new_today, new_prevDay, new_fromDate };
};
